// Essa constante é usada para controlar o acesso aos menus e operações do sistema
// a chave é a descrição da operação
// os valores são os ids das operações no banco de dados

const ControleAcessoOperacoes = {
  LogarRetaguardaWeb: 10001,
  // Cadastro: 10100
  Estabelecimento: 10138,
  EstabelecimentoAdicionar: 101381,
  EstabelecimentoAlterar: 101382,
  EstabelecimentoRemover: 101383,
  EstabelecimentoListar: 101384,

  AdquirenteTef: 10101,
  AdquirenteTefAdicionar: 101011,
  AdquirenteTefAlterar: 101012,
  AdquirenteTefRemover: 101013,
  AdquirenteTefListar: 101014,

  Aliquota: 10102,
  AliquotaAdicionar: 101021,
  AliquotaAlterar: 101022,
  AliquotaRemover: 101023,
  AliquotaListar: 101024,

  Bairro: 10103,
  BairroAdicionar: 101031,
  BairroAlterar: 101032,
  BairroRemover: 101033,
  BairroListar: 101034,

  BandeiraTef: 10104,
  BandeiraTefAdicionar: 101041,
  BandeiraTefAlterar: 101042,
  BandeiraTefRemover: 101043,
  BandeiraTefListar: 101044,

  CartaoConsumo: 10105,
  CartaoConsumoAdicionar: 101051,
  CartaoConsumoAlterar: 101052,
  CartaoConsumoRemover: 101053,
  CartaoConsumoListar: 101054,

  CategoriaTributaria: 10139,
  CategoriaTributariaListar: 101394,
  CategoriaTributariaAdicionar: 101391,
  CategoriaTributariaAlterar: 101392,
  CategoriaTributariaRemover: 101393,

  Cidade: 10106,
  CidadeAdicionar: 101061,
  CidadeAlterar: 101062,
  CidadeRemover: 101063,
  CidadeListar: 101064,

  Cofins: 10107,
  CofinsAdicionar: 101071,
  CofinsAlterar: 101072,
  CofinsRemover: 101073,
  CofinsListar: 101074,

  DisponibilidadeProdutos: 10108,
  DisponibilidadeProdutosAdicionar: 101081,
  DisponibilidadeProdutosAlterar: 101082,
  DisponibilidadeProdutosRemover: 101083,
  DisponibilidadeProdutosListar: 101084,

  DispositivoMovel: 10109,
  DispositivoMovelAdicionar: 101091,
  DispositivoMovelAlterar: 101092,
  DispositivoMovelRemover: 101093,
  DispositivoMovelListar: 101094,

  FichaFinanceira: 10110,
  FichaFinanceiraAdicionar: 101101,
  FichaFinanceiraAlterar: 101102,
  FichaFinanceiraRemover: 101103,
  FichaFinanceiraListar: 101104,

  FormaPagamento: 10111,
  FormaPagamentoAdicionar: 101111,
  FormaPagamentoAlterar: 101112,
  FormaPagamentoRemover: 101113,
  FormaPagamentoListar: 101114,

  Gatilho: 10112,
  GatilhoAdicionar: 101121,
  GatilhoAlterar: 101122,
  GatilhoRemover: 101123,
  GatilhoListar: 101124,

  GerenciadorNfe: 10141,
  GerenciadorNfeAdicionar: 101411,
  GerenciadorNfeAlterar: 101412,
  GerenciadorNfeRemover: 101413,
  GerenciadorNfeListar: 101414,

  GrupoOpcao: 10113,
  GrupoOpcaoAdicionar: 101131,
  GrupoOpcaoAlterar: 101132,
  GrupoOpcaoRemover: 101133,
  GrupoOpcaoListar: 101134,

  GrupoProdutos: 10114,
  GrupoProdutosAdicionar: 101141,
  GrupoProdutosAlterar: 101142,
  GrupoProdutosRemover: 101143,
  GrupoProdutosListar: 101144,

  ImpressoraComanda: 10115,
  ImpressoraComandaAdicionar: 101151,
  ImpressoraComandaAlterar: 101152,
  ImpressoraComandaRemover: 101153,
  ImpressoraComandaListar: 101154,

  LocalEstoque: 50000, // código ficticio

  MaquinaECF: 10116,
  MaquinaECFAdicionar: 101161,
  MaquinaECFAlterar: 101162,
  MaquinaECFRemover: 101163,
  MaquinaECFListar: 101164,

  MaquinaPOS: 10117,
  MaquinaPOSAdicionar: 101171,
  MaquinaPOSAlterar: 101172,
  MaquinaPOSRemover: 101173,
  MaquinaPOSListar: 101174,

  MarcaSAT: 10118,
  MarcaSATAdicionar: 101181,
  MarcaSATAlterar: 101182,
  MarcaSATRemover: 101183,
  MarcaSATListar: 101184,

  Mesa: 10119,
  MesaAdicionar: 101191,
  MesaAlterar: 101192,
  MesaRemover: 101193,
  MesaListar: 101194,

  ModalidadeTef: 10120,
  ModalidadeTefAdicionar: 101201,
  ModalidadeTefAlterar: 101202,
  ModalidadeTefRemover: 101203,
  ModalidadeTefListar: 101204,

  ModeloECF: 10121,
  ModeloECFAdicionar: 101211,
  ModeloECFAlterar: 101212,
  ModeloECFRemover: 101213,
  ModeloECFListar: 101214,

  MotivoCancelamento: 10122,
  MotivoCancelamentoAdicionar: 101221,
  MotivoCancelamentoAlterar: 101222,
  MotivoCancelamentoRemover: 101223,
  MotivoCancelamentoListar: 101224,

  MotivoTransferencia: 10123,
  MotivoTransferenciaAdicionar: 101231,
  MotivoTransferenciaAlterar: 101232,
  MotivoTransferenciaRemover: 101233,
  MotivoTransferenciaListar: 101234,

  MovimentacaoEstoque: 70000, // código ficticio

  Opcao: 10124,
  OpcaoAdicionar: 101241,
  OpcaoAlterar: 101242,
  OpcaoRemover: 101243,
  OpcaoListar: 101244,

  OperacaoNaoFiscal: 10125,
  OperacaoNaoFiscalAdicionar: 101251,
  OperacaoNaoFiscalAlterar: 101252,
  OperacaoNaoFiscalRemover: 101253,
  OperacaoNaoFiscalListar: 101254,

  Pdv: 10126,
  PdvAdicionar: 101261,
  PdvAlterar: 101262,
  PdvRemover: 101263,
  PdvListar: 101264,

  Pessoa: 10127,
  PessoaAdicionar: 101271,
  PessoaAlterar: 101272,
  PessoaRemover: 101273,
  PessoaListar: 101274,

  Pis: 10128,
  PisAdicionar: 101281,
  PisAlterar: 101282,
  PisRemover: 101283,
  PisListar: 101284,

  Praca: 10129,
  PracaAdicionar: 101291,
  PracaAlterar: 101292,
  PracaRemover: 101293,
  PracaListar: 101294,

  Produto: 10130,
  ProdutoAdicionar: 101301,
  ProdutoAlterar: 101302,
  ProdutoRemover: 101303,
  ProdutoListar: 101304,

  Regiao: 10131,
  RegiaoAdicionar: 101311,
  RegiaoAlterar: 101312,
  RegiaoRemover: 101313,
  RegiaoListar: 101314,

  SAT: 10132,
  SATAdicionar: 101321,
  SATAlterar: 101322,
  SATRemover: 101323,
  SATListar: 101324,

  SetorProducao: 10133,
  SetorProducaoAdicionar: 101331,
  SetorProducaoAlterar: 101332,
  SetorProducaoRemover: 101333,
  SetorProducaoListar: 101334,

  TabelaPreco: 10134,
  TabelaPrecoAdicionar: 101341,
  TabelaPrecoAlterar: 101342,
  TabelaPrecoRemover: 101343,
  TabelaPrecoListar: 101344,

  TransferenciaEstoque: 60000, // código ficticio
  TransferenciasProduto: 60001, // código ficticio

  Tara: 10135,
  TaraAdicionar: 101351,
  TaraAlterar: 101352,
  TaraRemover: 101353,
  TaraListar: 101354,

  Unidade: 10136,
  UnidadeAdicionar: 101361,
  UnidadeAlterar: 101362,
  UnidadeRemover: 101363,
  UnidadeListar: 101364,

  Voucher: 10137,
  VoucherAdicionar: 101371,
  VoucherAlterar: 101372,
  VoucherRemover: 101373,
  VoucherListar: 101374,

  ControleAcesso: 10190,
  ControleAcessoAdicionar: 101901,
  ControleAcessoAlterar: 101902,
  ControleAcessoRemover: 101903,
  ControleAcessoListar: 101904,

  ConsumoClientes: 10311,
  Crediario: 10312,
  CurvaABC: 10313,
  DesempenhoAtendente: 10314,
  DesempenhoEntregador: 10315,
  Estoque: 10316,
  FaturamentoDiarioMensal: 10317,
  FlashCaixa: 10318,
  InformacoesProdutos: 10319,
  ListagemClientes: 10320,
  LucroMensal: 10321,
  LucroProduto: 10322,
  OperacoesNaoFiscais: 10323,
  ProdutosCliente: 10324,
  ProdutosVendidosOperador: 10325,
  RaioX: 10326,
  RankingClientes: 10327,
  ResumoVendasEADelivery: 10328,
  SaldoDevedor: 10329,
  TaxaServicoData: 10330,
  TaxaServicoGarcom: 10331,
  TicketMedioClientePracas: 10332,
  TrocaFinalizadoras: 10333,
  Vendas: 10334,
  VendasCanceladas: 10335,
  VendasCategoria: 10336,
  VendasCliente: 10337,
  VendasFormaPagamento: 10338,
  VendasOperador: 10339,
  VendasProduto: 10340,
  Vouchers: 10341,
  AcompanhamentoPreVendas: 10301,
  AcompanhamentoPreVendasDelivery: 10302,
  AgendamentoEncomendas: 10303,
  AjusteEstoque: 10304,
  AuditoriaVendasPraca: 10305,
  AuditoriaVendasProdutos: 10306,
  AuditoriaTaxaServico: 10307,
  AuditoriaVendasVarejofacil: 10308,
  CancelamentoPreVendas: 10309,
  ClientesNaoCompraram: 10310,

  Relatorio: 10300, // Esse é uma operação geral de relatorios especifico da Web
  Configuracoes: 11000,

  MonitoramentoCfe: 2607,
}

// Essa constante é usada para controlar as dependências das operações
// a chave é o id da operação
// os valores são os ids das operações que também precisam ser ativadas
// quando a operação chave é ativada
const DependenciasOperacoes = {
  [String(ControleAcessoOperacoes.ProdutoListar)]: [
    String(ControleAcessoOperacoes.PisListar),
    String(ControleAcessoOperacoes.CofinsListar),
    String(ControleAcessoOperacoes.GrupoProdutosListar),
  ],
  [String(ControleAcessoOperacoes.Produto)]: [
    String(ControleAcessoOperacoes.Pis),
    String(ControleAcessoOperacoes.Cofins),
    String(ControleAcessoOperacoes.GrupoProdutos),
  ],
  [String(ControleAcessoOperacoes.Regiao)]: [String(ControleAcessoOperacoes.SetorProducao)],
}

export { ControleAcessoOperacoes, DependenciasOperacoes }
